import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

// css
import "./Contact.scss";

// img
import phone_icon from "../../../Assets/svg/phone_icon.svg";
import msg_icon from "../../../Assets/svg/msg_icon.svg";
import location_icon from "../../../Assets/svg/location_icon.svg";
import twitter_icon from "../../../Assets/svg/twitter_icon.svg";
import insta_icon from "../../../Assets/svg/insta_icon.svg";
import discord_icon from "../../../Assets/svg/discord_icon.svg";
import candleBg from "../../../Assets/images/candleBg.png";
import infoBg from "../../../Assets/images/auth.png";
import { Link } from "react-router-dom";
import ContactForm from "./ContactForm";

const Contact = () => {
  return (
    <>
      <section
        className="Contact position-relative"
        style={{
          backgroundImage: `url(${candleBg})`,
          backgroundSize: "cover",
          backgroundPosition: "top center",
          zIndex: 9,
        }}
      >
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="sectionHeader text-center">
                <h4 className="m-0 fw-bold head themeClr">Contact Us</h4>
                <p className="m-0 fw-sbold text-muted">
                  Any question or remarks? Just write us a message!
                </p>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="p-sm-3">
                <div className="cardCstm p-2 pb-0 bg-white">
                  <Row>
                    <Col lg="5">
                      <div
                        className="Info h-100 p-3 px-sm-4 position-relative"
                        style={{
                          backgroundImage: `url(${infoBg})`,
                          backgroundSize: "cover",
                          backgroundPosition: "top center",
                          zIndex: 9,
                        }}
                      >
                        <div className="top py-lg-3 py-2">
                          <h3 className="m-0 fw-bold text-white">
                            Contact Information
                          </h3>
                          <p className="m-0 py-1 text-white">
                            Say something to start a live chat!
                          </p>
                        </div>
                        <div className="bottom py-lg-3 py-2">
                          <ul
                            className="list-unstyled ps-0 mb-0 py-3 infoContent"
                            style={{ maxWidth: "300px" }}
                          >
                            <li className="py-3 d-flex align-items-start gap-10">
                              <span className="icn position-relative">
                                <img src={phone_icon} alt="" />
                              </span>
                              <p className="m-0 text-white">+1012 3456 789</p>
                            </li>
                            <li className="py-3 d-flex align-items-start gap-10">
                              <span className="icn position-relative">
                                <img src={msg_icon} alt="" />
                              </span>
                              <p className="m-0 text-white">demo@gmail.com</p>
                            </li>
                            <li className="py-3 d-flex align-items-start gap-10">
                              <span className="icn position-relative">
                                <img src={location_icon} alt="" />
                              </span>
                              <p className="m-0 text-white">
                                132 Dartmouth Street Boston, Massachusetts 02156
                                United States
                              </p>
                            </li>
                          </ul>
                          <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 social mt-3">
                            <li className="px-1">
                              <Link
                                to=""
                                className="d-flex align-items-center justify-content-center rounded-pill"
                              >
                                <img src={twitter_icon} alt="" />
                              </Link>
                            </li>
                            <li className="px-1">
                              <Link
                                to=""
                                className="d-flex align-items-center justify-content-center rounded-pill"
                              >
                                <img src={insta_icon} alt="" />
                              </Link>
                            </li>
                            <li className="px-1">
                              <Link
                                to=""
                                className="d-flex align-items-center justify-content-center rounded-pill"
                              >
                                <img src={discord_icon} alt="" />
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </Col>
                    <Col lg="7" className="formWrpper">
                      <ContactForm />
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Contact;
